import { handleResponse } from "utils/utils";
import { authService } from "services";

export const companyService = {
	getById,
	update,
	create,
	getConfig,
	updateConfig,
	getPaymentModels,
	getAccountsProductUsage,
	getProducts,
	getSubscriptionTypes,
	addSubscriptionRequest,
	getSubscriptionRequests,
	getSubscriptions,
	createSubscription,
	updateSubscription,
	removeSubscription,
	exportPartners,
	getOwner,
	updatePartnerEmployee,
};

// get company by id
function getById(companyId) {
	const requestOptions = {
		method: "GET",
		headers: {
			Authorization: `Bearer ${authService.token.access_token}`,
			"X-Ninja-In-Subscription-Process": "true",
		},
	};

	return fetch(`${global.BASE_API}companies/${companyId}`, requestOptions).then(
		handleResponse
	);
}

// create new company
function create(companyData) {
	const requestOptions = {
		method: "POST",
		headers: {
			Authorization: `Bearer ${authService.token.access_token}`,
			"Content-Type": "application/json",
		},
		body: JSON.stringify(companyData),
	};

	return fetch(`${global.BASE_API}companies/`, requestOptions).then(
		handleResponse
	);
}

// update company
function update(company) {
	const requestOptions = {
		method: "PUT",
		headers: {
			Authorization: `Bearer ${authService.token.access_token}`,
			"Content-Type": "application/json",
		},
		body: JSON.stringify(company),
	};

	return fetch(
		`${global.BASE_API}companies/${company.id}`,
		requestOptions
	).then(handleResponse);
}

// get company general config (supervisor flag + web terminal credentials)
// La respuesta nunca incluye web_terminal_password.
function getConfig() {
	const requestOptions = {
		method: "GET",
		headers: {
			Authorization: `Bearer ${authService.token.access_token}`,
			"Content-Type": "application/json",
		},
	};

	return fetch(`${global.BASE_API}companies/config`, requestOptions).then(
		handleResponse
	);
}

// update company general config.
// El back ignora web_terminal_password cuando llega vacío, así que para
// cambiar sólo el flag o el email se envía "".
function updateConfig(config) {
	const requestOptions = {
		method: "PUT",
		headers: {
			Authorization: `Bearer ${authService.token.access_token}`,
			"Content-Type": "application/json",
		},
		body: JSON.stringify(config),
	};

	return fetch(`${global.BASE_API}companies/config`, requestOptions).then(
		handleResponse
	);
}

// gets payment models
function getPaymentModels() {
	const requestOptions = {
		method: "GET",
		headers: {
			Authorization: `Bearer ${global.API_KEY}`,
			"Content-Type": "application/json",
		},
	};

	return fetch(`${global.BASE_API}apps/payment-models`, requestOptions).then(
		handleResponse
	);
}

// Devuelve el estado del producto de cuentas (firmas): { signatures_allowance, signatures_used }
function getAccountsProductUsage() {
	const requestOptions = {
		method: "GET",
		headers: {
			Authorization: `Bearer ${authService.token.access_token}`,
		},
	};

	return fetch(`${global.BASE_API}companies/products/accounts`, requestOptions)
	    .then((response) => handleResponse(response, { ignore401: true }));
	// return fetch(
	// 	`https://app.plain.ninja/saas/api/companies/products/accounts`,
	// 	requestOptions
	// ).then((response) => handleResponse(response, { ignore401: true }));
}

// get company's products
function getProducts(companyId) {
	const requestOptions = {
		method: "GET",
		headers: {
			Authorization: `Bearer ${authService.token.access_token}`,
			"Content-Type": "application/json",
		},
	};

	return fetch(
		`${global.BASE_API}companies/${companyId}/products`,
		requestOptions
	).then(handleResponse);
}

// COMPANY'S SUBSCRIPTIONS

// get subscription types
function getSubscriptionTypes() {
	const requestOptions = {
		method: "GET",
		headers: {
			Authorization: `Bearer ${authService.token.access_token}`,
			"Content-Type": "application/json",
		},
	};

	return fetch(
		`${global.BASE_API}apps/subscription-types`,
		requestOptions
	).then(handleResponse);
}

// add new subscription request
// "X-Ninja-In-Subscription-Process" : "true"
function addSubscriptionRequest(request) {
	const requestOptions = {
		method: "POST",
		headers: {
			Authorization: `Bearer ${authService.token.access_token}`,
			"Content-Type": "application/json",
			"X-Ninja-In-Subscription-Process": "true",
		},
		body: JSON.stringify(request),
	};

	return fetch(
		`${global.BASE_API}companies/${request.company.id}/subscriptions-requests`,
		requestOptions
	).then(handleResponse);
}

// get subscription requests
function getSubscriptionRequests(companyId) {
	const requestOptions = {
		method: "GET",
		headers: {
			Authorization: `Bearer ${authService.token.access_token}`,
			"Content-Type": "application/json",
		},
	};

	return fetch(
		`${global.BASE_API}companies/${companyId}/subscriptions-requests`,
		requestOptions
	).then(handleResponse);
}

// get company's subscriptions
function getSubscriptions(companyId) {
	const requestOptions = {
		method: "GET",
		headers: {
			Authorization: `Bearer ${authService.token.access_token}`,
			"Content-Type": "application/json",
			"X-Ninja-In-Subscription-Process": "true",
		},
	};

	return fetch(
		`${global.BASE_API}companies/${companyId}/subscriptions`,
		requestOptions
	).then(handleResponse);
}

// create new subscription?
function createSubscription(companyId, subscriptionData) {
	const requestOptions = {
		method: "POST",
		headers: {
			Authorization: `Bearer ${authService.token.access_token}`,
			"Content-Type": "application/json",
		},
		body: JSON.stringify(subscriptionData),
	};

	return fetch(
		`${global.BASE_API}companies/${companyId}/subscriptions`,
		requestOptions
	).then(handleResponse);
}

// update subscription
function updateSubscription(companyId, subscription) {
	const requestOptions = {
		method: "PUT",
		headers: {
			Authorization: `Bearer ${authService.token.access_token}`,
			"Content-Type": "application/json",
		},
		body: JSON.stringify(subscription),
	};

	return fetch(
		`${global.BASE_API}companies/${companyId}/subscriptions/${subscription.id}`,
		requestOptions
	).then(handleResponse);
}

// export partner companies to Excel
function exportPartners(options = {}) {
	const requestOptions = {
		method: "GET",
		headers: {
			Authorization: `Bearer ${authService.token.access_token}`,
		},
	};

	let query = "";
	if (options.q) query += `?q=${options.q}`;

	return fetch(`${global.BASE_API}companies/export-partners${query}`, requestOptions).then(
		handleResponse
	);
}

// get owner of a partner company
function getOwner(companyId) {
	const requestOptions = {
		method: "GET",
		headers: {
			Authorization: `Bearer ${authService.token.access_token}`,
		},
	};

	return fetch(`${global.BASE_API}companies/${companyId}/owner`, requestOptions).then(
		handleResponse
	);
}

// update an employee belonging to a partner company
function updatePartnerEmployee(companyId, employeeId, data) {
	const requestOptions = {
		method: "PUT",
		headers: {
			Authorization: `Bearer ${authService.token.access_token}`,
			"Content-Type": "application/json",
		},
		body: JSON.stringify(data),
	};

	return fetch(
		`${global.BASE_API}companies/${companyId}/employees/${employeeId}`,
		requestOptions
	).then(handleResponse);
}

// remove subscription
function removeSubscription(companyId, subscriptionId) {
	const requestOptions = {
		method: "DELETE",
		headers: {
			Authorization: `Bearer ${authService.token.access_token}`,
		},
	};

	return fetch(
		`${global.BASE_API}companies/${companyId}/subscriptions/${subscriptionId}`,
		requestOptions
	).then(handleResponse);
}
